module.exports = __webpack_public_path__ + "img/downtrend.1b9adff2.svg";